import React, {useState, useEffect} from "react";
import {
    Typography,
    Grid,
    TextField as RTextField,
    Box,
    Button,
    makeStyles,
    Container,
} from "@material-ui/core";
import LaunchIcon from "@material-ui/icons/Launch";
import Api from "../../../helpers/apiHelpers";
import Autocomplete from "@mui/lab/Autocomplete";
import {specialities} from "../../../constants/specialities";
import {ErrorMessage} from "formik";
import {getUserProfile, patchUserProfile} from "../../../redux/userProfile/userProfile.actions";
import {useSnackbar} from "notistack";
import {useAppDispatch} from "../../../redux/store";
import {useLocation} from "react-router";

interface Props {
    changeCount: (number: number) => void;
};

const useStyle = makeStyles(() => ({
        body: {
            paddingTop: 20,
        },
    })
)
const CommunicationPref = ({changeCount}:Props) => {
    const classes = useStyle();
    const { enqueueSnackbar } = useSnackbar();
    const user = JSON.parse(localStorage.getItem("auth"));
    const dispatch = useAppDispatch();
    const [communication, setCommunication] = useState("");
    const [id, setId] = useState(0);
    const options = [
        {value: "call", label: "Call"},
        {value: "email", label: "Email"},
        {value: "text", label: "Text"},
    ]

    useEffect(() => {
        dispatch(getUserProfile({userId: user.userId})).then((profile) => {
            // Presetting fields with data from BE
            setId(profile[0].id)
            setCommunication(profile[0].bestWayToBeReached)
        }).catch(err => enqueueSnackbar(err.errorMessage, {
            variant: "error",
            autoHideDuration: 4000
        }));
    },[]);

    const handleSubmit = () => {
        const userId = user.userId;
        dispatch(patchUserProfile({id: id, body: {bestWayToBeReached: communication, userId, type: "vet"}}));
    }

    return (
        <Container className={classes.body} disableGutters={true}>
            <Typography variant="h2" gutterBottom>
                Provide communication preferences
            </Typography>
            <Grid item xs={12}  sm={9}>
                <Autocomplete
                    value={communication}
                    fullWidth={true}
                    options={options}
                    renderInput={(params) => <RTextField {...params} variant="outlined" />}
                    onChange={(event, value) => {
                        setCommunication(value?.value)
                    }}
                />
            </Grid>
            <Button style={{marginTop: "20px", minWidth: "100px"}} variant="contained" color="secondary" onClick={() => {
                handleSubmit()
                changeCount(1);
            }}>Next</Button>
        </Container>
    )
}
export default CommunicationPref
